interface ModalHeaderProps {
    children: React.ReactNode;
}

export default function ModalHeader({ children }: ModalHeaderProps) {
    return children;
}
